var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 10.0002H26.6665V18.3335H13.3332V10.0002Z",
    fill: "#2771bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6665 21.6668H23.3332V30.0002H26.6665V21.6668Z",
    fill: "#2771bb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 26.6668H21.6665V30.0002H18.3332V26.6668Z",
    fill: "#2771bb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 26.6668H13.3332V30.0002H16.6665V26.6668Z",
    fill: "#2771bb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 21.6668H16.6665V25.0002H13.3332V21.6668Z",
    fill: "#2771bb"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 21.6668H18.3332V25.0002H21.6665V21.6668Z",
    fill: "#2771bb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 3.3335C8.15889 3.3335 6.6665 4.82588 6.6665 6.66683V33.3335C6.6665 35.1744 8.15889 36.6668 9.99984 36.6668H29.9998C31.8408 36.6668 33.3332 35.1744 33.3332 33.3335V6.66683C33.3332 4.82588 31.8408 3.3335 29.9998 3.3335H9.99984ZM29.9998 6.66683H9.99984V33.3335H29.9998V6.66683Z",
    fill: "#2771bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.ec65afe3c00e2b2e039d6c975de30f00.svg";
export { ForwardRef as ReactComponent };